interface Props {
  readonly size?: number;
}

export default function KeyIcon(props: Props) {
  const { size = 19 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path opacity=".446" d="M0 0h24v24H0z" />
        <g
          transform="scale(1 -1) rotate(30 42.76 -.894)"
          stroke="#CC38FF"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            d="M21 4.75H9.224M19.046.475v3.8m-4.749-3.8v3.8"
          />
          <circle cx="4.75" cy="4.75" r="3.75" />
        </g>
      </g>
    </svg>
  );
}
